import secureLocalStorage  from  "react-secure-storage";

// 환경변수 또는 기본값 사용 (SSR에서 import.meta 사용 불가)
const ACCESS_TOKEN_NAME = (typeof process !== 'undefined' && process.env?.VITE_ACCESS_TOKEN_NAME) 
    || 'e8b7ecccfd63df99bab8275da976487a';
const REFRESH_TOKEN_NAME = (typeof process !== 'undefined' && process.env?.VITE_REFRESH_TOKEN_NAME) 
    || '09eaa569d93429d8f5de68722cd47cd1';

export function setAuthKey(access, refresh) {
    secureLocalStorage.setItem(ACCESS_TOKEN_NAME, access);
    secureLocalStorage.setItem(REFRESH_TOKEN_NAME, refresh);
}

export function clearAuthKey() {
    secureLocalStorage.removeItem(ACCESS_TOKEN_NAME);
    secureLocalStorage.removeItem(REFRESH_TOKEN_NAME);
}

export function setAccessKey(access) {
    secureLocalStorage.setItem(ACCESS_TOKEN_NAME, access);
}

export function setRefreshKey(refresh) {
    secureLocalStorage.setItem(REFRESH_TOKEN_NAME, refresh);
}

export function getAccessKey() {
    return secureLocalStorage.getItem(ACCESS_TOKEN_NAME);
}

export function getRefreshKey() {
    return secureLocalStorage.getItem(REFRESH_TOKEN_NAME);
}

